import {
  TRI_STATE_FILTER_OPTIONS,
  TrayFilterSegmentRow,
  TraySearchSuggestInput,
} from '@components/app/panels/right-panel/tray'
import type { PortraitsPlacedFilter } from '@/lib/portraits/types/portraits-placed-filter'
import type { PortraitFilterDropdown } from '../types/portrait-filter-dropdown'
import { PortraitsFilterCombo } from './portraits-filter-combo'

type PortraitsTrayFiltersProps = {
  nameQuery: string
  onNameQueryChange: (query: string) => void
  /** Matching full names for the "Search students" dropdown, closest match first. */
  nameSuggestions: string[]
  onNameSuggestionsOpenChange: (open: boolean) => void
  grade: PortraitFilterDropdown
  homeroom: PortraitFilterDropdown
  custom: PortraitFilterDropdown
  placedFilter: PortraitsPlacedFilter
  onPlacedFilterChange: (placed: PortraitsPlacedFilter) => void
}

/** Controls inside the Portraits tray's Filters section: name search first, then the Grade /
 *  Homeroom / Custom dropdowns and the Placed row (the shared Any / Yes / No segments Backgrounds
 *  uses). While a dropdown's options load or fail it says so, as the other trays' comboboxes do. */
export function PortraitsTrayFilters({
  nameQuery,
  onNameQueryChange,
  nameSuggestions,
  onNameSuggestionsOpenChange,
  grade,
  homeroom,
  custom,
  placedFilter,
  onPlacedFilterChange,
}: PortraitsTrayFiltersProps) {
  return (
    <div className="flex flex-col gap-3 px-4 pb-2 pt-2">
      <TraySearchSuggestInput
        value={nameQuery}
        onChange={onNameQueryChange}
        placeholder="Search students"
        suggestions={nameSuggestions}
        onOpenChange={onNameSuggestionsOpenChange}
      />
      <PortraitsFilterCombo
        filter={grade}
        placeholder="Choose grade"
        ariaLabel="Grade"
        noun="grades"
      />
      <PortraitsFilterCombo
        filter={homeroom}
        placeholder="Choose homeroom"
        ariaLabel="Homeroom"
        noun="homerooms"
      />
      <PortraitsFilterCombo
        filter={custom}
        placeholder="Choose custom"
        ariaLabel="Custom"
        noun="custom groups"
      />
      <TrayFilterSegmentRow
        label="Placed"
        value={placedFilter}
        options={TRI_STATE_FILTER_OPTIONS}
        onChange={onPlacedFilterChange}
      />
    </div>
  )
}
